import { Outlet } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import users from 'modules/core/store/collections/users'

import FoldersSettings from 'modules/documents/components/Settings/Folders'
import { SPACES } from 'modules/documents/lib/constants'

const InternalFolderSettingPage = () => {
  const space = SPACES.COMPANY_INTERNAL
  const folderVariables = { space, rootFolders: true }
  const { company } = useCurrentSession()

  const { navigation } = useNavigation()

  return (
    <>
      <Outlet
        context={{
          parentRoute: navigation.settings.folders.internal.fullPath(),
          space,
          companyId: company.id,
        }}
      />

      <FoldersSettings
        space={space}
        folderVariables={folderVariables}
        canManage={users.current.policy.can('documents.companyManageFolders')}
        newFolderRoute={navigation.settings.folders.internal.new.fullPath()}
      />
    </>
  )
}

export default InternalFolderSettingPage
